import { getInputProps, type FieldMetadata } from "@conform-to/react"
import * as React from "react"

import { cn } from "#app/utils/misc.tsx"

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
	meta: FieldMetadata<string | number | undefined>
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
	({ className, meta, ...props }, ref) => {
		return (
			<textarea
				className={cn(
					"flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm placeholder:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
					className,
				)}
				ref={ref}
				{...meta}
				{...getInputProps(meta, { type: "text" })}
				{...props}
			/>
		)
	},
)
Textarea.displayName = "Textarea"

export { Textarea }
